import { Component, OnInit, OnDestroy } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { Subscription } from 'rxjs';

import { ThemeService } from 'rev-portal/branding/Theme.Service';

import { IUserContextAccount, IUserContextUser, UserContextService } from 'rev-shared/security/UserContext.Service';
import { StateChangeStatus } from 'rev-shared/util/StateChangeStatus.Service';

@Component({
	selector: 'embed-component',
	templateUrl: './Embed.Component.html',
	standalone: false
})
export class EmbedComponent implements OnInit, OnDestroy {
	public account: any;
	public accountId: string;
	public isUserAuthenticated: boolean;
	public user: any;
	public userId: string;

	private userContextChangeSubscription: Subscription;

	constructor(
		public $state: StateService,
		public StateChangeStatus: StateChangeStatus,
		public UserContext: UserContextService,
		public ThemeService: ThemeService
	) {}

	public ngOnInit(): void {
		this.userContextChangeSubscription = this.UserContext.user$.subscribe(() => this.onUserContextChange());
	}

	public ngOnDestroy(): void {
		this.userContextChangeSubscription.unsubscribe();
	}

	private onUserContextChange(): void {
		const user: IUserContextUser = this.UserContext.getUser();
		const account: IUserContextAccount = this.UserContext.getAccount();

		Object.assign(this, {
			account,
			user,
			userId: user.id,
			accountId: account.id,
			isUserAuthenticated: this.UserContext.isUserAuthenticated()
		});
	}
}
